import { Component, OnInit, Input } from "@angular/core";

import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-mech-user-access",
	templateUrl: "./mech-user-access.component.html",
	styleUrls: ["./mech-user-access.component.scss"]
})
export class MechUserAccessComponent implements OnInit {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;

	public totalLogs = 0;
	public currentPage = 1;
	public itemsPerPage = 30;
	public pageLogs: any[] = undefined;

	constructor(public api: ApiService) { }

	async ngOnInit() {
		this.refreshTable();
	}

	async updatePage() {
		const result = await this.api.GetAssetAccess(this.asset.asset_id, this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage);
		this.totalLogs = result.count;
		this.pageLogs = result.rows;
	}

	refreshTable() {
		this.currentPage = 1;
		this.updatePage();
	}
}
